/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Tabs_PaymentInputs */

const en_admin_settings_tabs_payment = /** @type {(inputs: Admin_Settings_Tabs_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment`)
};

/**
* | output |
* | --- |
* | "Payment" |
*
* @param {Admin_Settings_Tabs_PaymentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_tabs_payment = /** @type {((inputs?: Admin_Settings_Tabs_PaymentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Tabs_PaymentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_tabs_payment(inputs)
});
export { admin_settings_tabs_payment as "admin.settings.tabs.payment" }